import React from 'react'

const eventDash = () => {
  return (
    <div>eventDash</div>
  )
}

export default eventDash